/*
 * Copyright (c) 2005-2024, Paycheck Planner
 * All rights reserved
 * 
 */

import { AST } from './runtime-parser/ast.js';
import VM from './runtime-parser/vm.js';


//---------------------------------------------------------------------------------------
//---------------------------------------------------------------------------------------

class Runtime {
  constructor() {
    this.vm = new VM();
  }


  /**
   * Evaluate all the Date Expressions inside all the model entities
   * @param {SimulationModelModel} simModel 
   */
  evaluateModelDates(simModel ) {
    const begin_time = Date.now();

    this.buildDependencyGraph(simModel.symbols);
    this.sortDependencyGraph(simModel.symbols);
    this.vm.evaluateAllExpressions(simModel.symbols);

    const total_time = Date.now() - begin_time;

    let ret = {
      totalTime: total_time,
    }

    return ret;
  }


  // TODO this and remaining vm functions may move out of here
  evaluateExpression( symbolTree, ast ) {

    let val = this.vm.evaluateExpression( symbolTree, ast );
  
    return val;
  }


  //---------------------------------------------------------------------------------------
  //---------------------------------------------------------------------------------------
  //    private functions
  //---------------------------------------------------------------------------------------
  //---------------------------------------------------------------------------------------

  /**
   * For each item expression in a model, analyzes their AST and generates a 
   * list of dependencies 
   * @param {Model} model 
   */
  buildDependencyGraph(symbolTree) {
    let num_exprs = symbolTree.allNames.length;

    for (let i = 0; i < num_exprs; i++) {
      let name = symbolTree.allNames[i];
      let sym = symbolTree[name];

      this.analyzeExpression( symbolTree, sym, sym.expr );
    }
  }


  /**
   * 
   * @param {Model} model 
   * @param {Symbol} root 
   * @param {*} expr 
   */
  analyzeExpression( symbolTree, root, expr ) {
    if ( expr.nodeType === AST.NODETYPE_IDENT ) {
      if ( expr.ident in symbolTree ) {
        var dep = symbolTree[expr.ident];
        // Root expression depends on this symbol
        root.dependencies.push( expr. ident );
        // All the expressions that depend on it
        this.updateDependents( dep, root );

        this.analyzeExpression( symbolTree, root, dep.expr );
      }
    }
    else if ( expr.nodeType === AST.NODETYPE_FUNCTION ) {
      var num_params = expr.params.length;
      for ( var i = 0; i < num_params; i++ ) {
        this.analyzeExpression( symbolTree, root, expr.params[i]);
      }
    }
  }


  /**
   * 
   * @param {Symbol} item 
   * @param {Item} dependent 
   */
  updateDependents( item, dependent ) {
    item.dependents.push( dependent.name );
    item.uiDependents.push( dependent.owner.name );
  }

/*
L ← Empty list that will contain the sorted elements
S ← Set of all nodes with no incoming edge
while S is non-empty do
    remove a node n from S
    add n to tail of L
    for each node m with an edge e from n to m do
        remove edge e from the graph
        if m has no other incoming edges then
            insert m into S
if graph has edges then
    return error   (graph has at least one cycle)
else
    return L   (a topologically sorted order)
*/
  sortDependencyGraph(symbolTree) {
    var name = "";
    var sym = null;

    var l = [];
    var s = [];

    // make S
    var num_exprs = symbolTree.allNames.length;

    for (var i = 0; i < num_exprs; i++) {
      name = symbolTree.allNames[i];
      sym = symbolTree[name];

      if (sym.dependencies.length === 0) { // Set of all nodes with no incoming edge
        s.push(name);
      }
    }


    while (s.length > 0) {  // while S is non-empty do
      name = s.pop();   // remove a node n from S
      l.push(name);     // add n to tail of L

      sym = symbolTree[name];
      var num_dependents = sym.dependents.length;

      for ( let i = 0; i < num_dependents; i++) {  // for each node m with an edge e from n to m do
        var dep_name = sym.dependents.pop();    // remove edge e from the graph
        var dep_sym = symbolTree[dep_name];
        var idx = dep_sym.dependencies.indexOf(name);
        dep_sym.dependencies.splice(idx,1); // remove edge e from the graph

        if (dep_sym.dependencies.length === 0) {
          s.push(dep_name);
        }
      }
    } // while s not empty

    symbolTree.allNames = l;

    //console.log(l);
  }

}


export const model_runtime = new Runtime();
